import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext } from 'react';
import { delay } from 'lodash';
import { Box } from '@hub/box';
import { CoreContainer } from '@hub/core-container';
import { useToken } from '@hub/design-system-base';
import { useAnalytics } from '@scentregroup/shared/analytics';
import { transformNavigationClickedItemsData } from '../../../analytics-segment/events/navigation-item';
import { LinkContext } from '../../../context';
import { MainNavItemWrapper } from './main-nav-item-wrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const SimpleMenu = _ref => {
  let {
    itemId,
    itemLabel,
    index,
    menuItems,
    megamenuFocusRef,
    liComponentRef
  } = _ref;
  const leftPadding = useToken('space', index === 0 ? 'spacing-md' : 'spacing-sm');
  const Link = useContext(LinkContext);
  const left = liComponentRef ? (liComponentRef === null || liComponentRef === void 0 ? void 0 : liComponentRef.getBoundingClientRect().x) - parseInt(leftPadding) : 0;
  const analytics = useAnalytics();
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      position: 'absolute',
      top: '100%',
      zIndex: 'dropdown',
      left
    },
    role: "none",
    ref: box => {
      if (box && megamenuFocusRef !== null && megamenuFocusRef !== void 0 && megamenuFocusRef.current) {
        const DELAY_FOR_MAKING_SURE_FOCUS_IS_POSSIBLE = 50;
        delay(() => {
          var _box$querySelector;
          return (_box$querySelector = box.querySelector('a')) === null || _box$querySelector === void 0 ? void 0 : _box$querySelector.focus();
        }, DELAY_FOR_MAKING_SURE_FOCUS_IS_POSSIBLE);
        megamenuFocusRef.current = false;
      }
    },
    "data-id": "tabs_simple-menu_SimpleMenu_Box",
    children: /*#__PURE__*/_jsx(CoreContainer, {
      as: "ul",
      tabIndex: -1,
      id: itemId,
      sx: {
        fontSize: 'font-sm',
        paddingY: 'spacing-md',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        alignContent: 'space-between',
        minWidth: 'size-md',
        marginTop: '1px',
        backgroundColor: 'white'
      },
      gutter: 'spacing-md',
      "data-id": "tabs_simple-menu_SimpleMenu_Box_CoreContainer",
      children: menuItems && menuItems.map((menuItem, i) => /*#__PURE__*/_jsx(MainNavItemWrapper, {
        sx: {
          paddingTop: 'spacing-xs'
        },
        "data-id": "tabs_simple-menu_SimpleMenu_MainNavItemWrapper",
        children: /*#__PURE__*/_jsx(Link, {
          to: menuItem.url,
          component: _ref2 => {
            let {
                children
              } = _ref2,
              props = _objectWithoutProperties(_ref2, _excluded);
            return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, props), {}, {
              "data-id": "tabs_simple-menu_SimpleMenu_a",
              children: children
            }));
          },
          id: "megamenu-item-".concat(i),
          onClick: () => {
            transformNavigationClickedItemsData(analytics, {
              parentLabel: itemLabel,
              itemLabel: menuItem.label,
              link: menuItem.url
            });
          },
          "data-id": "tabs_simple-menu_SimpleMenu_MainNavItemWrapper_Link",
          children: menuItem.label
        })
      }, "".concat(menuItem.url, "-").concat(menuItem.label)))
    })
  });
};